import React, { useState, useEffect, memo } from "react";
import Icon from "@alboompro/boom-components/general/icon";
import { LabelWrapper, TooltipWrapper, Popover } from "./styles";

const EditorLabel = ({ children, tooltip = null, fontSize = 12 }) => {
  const [active, setActive] = useState(false);
  const handleWindowClick = () => setActive(false);

  useEffect(() => {
    const act = active ? "addEventListener" : "removeEventListener";
    window[act]("click", handleWindowClick);
    return () => {
      window.removeEventListener("click", handleWindowClick);
    };
  });

  return (
    <LabelWrapper withTooltip={tooltip !== null} fontSize={fontSize}>
      <div>{children}</div>
      {tooltip && (
        <div>
          <TooltipWrapper>
            <span
              className="trigger"
              onClick={e => {
                e.stopPropagation();
                setActive(!active);
              }}
            >
              <Icon
                kind="light"
                group="interface-essential"
                category="alerts"
                file="question-circle.svg"
                size="14"
                color="#858585"
              />
            </span>
            <Popover
              active={active}
              dangerouslySetInnerHTML={{ __html: tooltip }}
            />
          </TooltipWrapper>
        </div>
      )}
    </LabelWrapper>
  );
};

export default memo(EditorLabel);
